import { RECEIVE_FEED_ITEMS } from 'portal-modules/community-feed/redux/modules/feed'
import { LOGOUT } from 'portal-modules/auth/redux/modules/user'

export default (state = {}, { payload, type }) => {
  switch (type) {
    case RECEIVE_FEED_ITEMS:
      return Object.keys(payload.announcements).length
        ? {
            ...state,
            ...payload.announcements,
          }
        : state

    case LOGOUT:
      return {}
    default:
      return state
  }
}
